import { Icon } from '@iconify/react'
import { Link } from 'react-router-dom'
import type { InstitutionDonorQuestionnaireAnswer } from '@/types/institution-donor'
import { formatDateTime } from '@/lib/campaign-dashboard'
import styles from './DonorQuestionnaireSection.module.css'

interface DonorQuestionnaireSectionProps {
  answers: InstitutionDonorQuestionnaireAnswer[]
}

function formatAnsweredAt(iso: string | null): string | null {
  if (!iso) return null
  const formatted = formatDateTime(iso)
  return formatted === '—' ? null : formatted
}

export function DonorQuestionnaireSection({ answers }: DonorQuestionnaireSectionProps) {
  if (answers.length === 0) {
    return null
  }

  return (
    <section className={styles.section} aria-labelledby="donor-questionnaire-title">
      <h3 id="donor-questionnaire-title" className={styles.title}>
        <Icon icon="mdi:help-circle-outline" className={styles.titleIcon} aria-hidden />
        Questionário pós-pagamento
      </h3>
      <p className={styles.intro}>
        Respostas enviadas pelo cliente após a confirmação do pagamento, por campanha e pedido.
      </p>
      <ul className={styles.list}>
        {answers.map((answer) => {
          const answeredAt = formatAnsweredAt(answer.answered_at)
          const paidAt = formatAnsweredAt(answer.paid_at)
          return (
            <li
              key={`${answer.payment_id}-${answer.question_id}-${answer.option_id}`}
              className={styles.item}
            >
              <div className={styles.itemHeader}>
                <span className={styles.campaignName}>{answer.campaign_title}</span>
                <div className={styles.itemMeta}>
                  <Link
                    to={`/pedidos/lista/pedido/${answer.payment_id}`}
                    className={styles.orderLink}
                  >
                    <Icon icon="mdi:receipt-text-outline" className={styles.orderLinkIcon} aria-hidden />
                    Pedido #{answer.payment_id}
                  </Link>
                  {paidAt ? (
                    <span className={styles.paidAt}>Pago em {paidAt}</span>
                  ) : null}
                </div>
              </div>
              <p className={styles.question}>{answer.question_title}</p>
              <p className={styles.answer}>
                Resposta: <strong>{answer.option_label}</strong>
              </p>
              {answeredAt ? (
                <span className={styles.answeredAt}>Respondido em {answeredAt}</span>
              ) : null}
            </li>
          )
        })}
      </ul>
    </section>
  )
}
